module.exports = __webpack_public_path__ + "static/media/submit-btn.9184f9f5.png";